import { connect } from 'react-redux';
import { compose } from 'recompose';
import DetailsProcessor from './DetailsProcessor';

import { openTicketEntryForm } from '../../forms/TicketEntry/actions';
import { deleteTicket } from '../actions';

const mapDispatchToProps = {
  openTicketEntryForm,
  deleteTicketAction: deleteTicket,
};

const withRedux = connect(null, mapDispatchToProps);

const enhance = compose(withRedux);

export default enhance(DetailsProcessor);
